export default "__VITE_ASSET__BLZSpcNS__"